/* eslint-disable react/prop-types */

import React from 'react';

import ImageText from './ImageText/ImageText';
import StatementImage from './StatementImage/StatementImage';
import ImageGallery from './ImageGallery/ImageGallery';
import VideoGallery from './VideoGallery/VideoGallery';
import Spotify from './Spotify/Spotify';
import Soundcloud from './Soundcloud/Soundcloud';
import Story from 'components/Story/Story';
import Expandable from 'components/Expandable/Expandable';
import StatementText from './StatementText/StatementText';
import ProfileVideo from './ProfileVideo/ProfileVideo';
import VideoText from './VideoText/VideoText';
import SpannedStatement from './SpannedStatement/SpannedStatement';
import SpannedImageText from './SpannedImageText/SpannedImageText';
import CenteredText from './CenteredText/CenteredText';
import SpannedVideo from './SpannedVideo/SpannedVideo';
import Interview from 'components/Interview/Interview';
import StatementVideo from './StatementVideo/StatementVideo';
import Ensemble from './Ensemble/Ensemble';

const content = {
  imageText: ImageText,
  statementImage: StatementImage,
  imageGallery: ImageGallery,
  videoGallery: VideoGallery,
  spotify: Spotify,
  soundcloud: Soundcloud,
  story: Story,
  statementText: StatementText,
  profileVideo: ProfileVideo,
  videoText: VideoText,
  spannedStatement: SpannedStatement,
  spannedImageText: SpannedImageText,
  centeredText: CenteredText,
  spannedVideo: SpannedVideo,
  interview: Interview,
  statementVideo: StatementVideo,
  actors: Ensemble,
  artisticStab: Ensemble,
  band: Ensemble,
  contributors: Ensemble,
  expandable: Expandable,
};

export default ({ type, ...props }, key) => {
  const Block = content[type] ?? null;
  if (!Block) return null;

  return <Block key={key} type={type} {...props} />;
};
